import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell, ReferenceLine } from 'recharts';
import GrowthMetrics from '../metrics/GrowthMetrics';
import { CHART_COLORS, CHART_CONFIG, formatYAxisValue, formatCurrencyValue } from '../../constants/chartConfig';

const WaterfallChart = ({
  data,
  title,
  subtitle,
  growthMetrics,
  growthMetricsTitle
}) => {
  if (!data || data.length === 0) return null;

  // Custom tooltip formatter
  const tooltipFormatter = (value, name, props) => {
    const dataPoint = props.payload;
    if (dataPoint.isStart || dataPoint.isEnd) {
      return [formatCurrencyValue(dataPoint.total), 'Total Returns'];
    } else {
      const changeText = dataPoint.change >= 0 ? 'Increase' : 'Decrease';
      return [
        `${changeText}: ${formatCurrencyValue(Math.abs(dataPoint.change))}`,
        `Running Total: ${formatCurrencyValue(dataPoint.total)}`
      ];
    }
  };

  return (
    <div className="bg-white p-8 rounded-xl border shadow-sm">
      {/* Header */}
      <div className="flex items-center justify-between mb-4">
        <div>
          <h3 className="text-xl font-semibold mb-2">{title}</h3>
          {subtitle && <p className="text-sm text-gray-600">{subtitle}</p>}
        </div>
      </div>

      {/* Chart */}
      <div className="mb-8" style={{ height: CHART_CONFIG.HEIGHT }}>
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data}>
            <CartesianGrid strokeDasharray="3 3" stroke={CHART_COLORS.GRID} />
            <XAxis
              dataKey="name"
              tick={{ fill: CHART_COLORS.TEXT, fontSize: 12 }}
            />
            <YAxis
              tick={{ fill: CHART_COLORS.TEXT, fontSize: 12 }}
              tickFormatter={formatYAxisValue}
              width={CHART_CONFIG.Y_AXIS_WIDTH}
            />
            <Tooltip
              contentStyle={CHART_CONFIG.TOOLTIP_STYLE}
              formatter={tooltipFormatter}
              labelFormatter={(label) => label}
            />
            <ReferenceLine y={0} stroke={CHART_COLORS.REFERENCE_LINE} />

            {/* Base bar (invisible) */}
            <Bar dataKey="base" stackId="stack" fill="transparent" />

            {/* Value bar (colored) */}
            <Bar dataKey="value" stackId="stack">
              {data.map((entry, index) => (
                <Cell
                  key={`cell-${index}`}
                  fill={
                    entry.isStart || entry.isEnd ? CHART_COLORS.TOTAL :
                    entry.isIncrease ? CHART_COLORS.INCREASE :
                    entry.isDecrease ? CHART_COLORS.DECREASE :
                    CHART_COLORS.TOTAL
                  }
                />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>

      {/* Growth Metrics Below Chart */}
      {growthMetrics && (
        <GrowthMetrics
          metrics={growthMetrics}
          title={growthMetricsTitle || 'Growth Percentage by Category'}
        />
      )}
    </div>
  );
};

export default WaterfallChart;
